"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _vue = _interopRequireDefault(require("vue"));

var _vuex = _interopRequireDefault(require("vuex"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_vue["default"].use(_vuex["default"]);

var store = new _vuex["default"].Store({
  state: {},
  mutations: {
    set: function set(state, payload) {
      _vue["default"].set(state, payload.state, payload.value);
    },
    del: function del(_state, payload) {
      this.commit('set', {
        state: payload.state,
        value: undefined
      });
    }
  }
});

store.get = function (state) {
  return store.state[state];
};

store.set = function (state, value) {
  return store.commit('set', {
    state: state,
    value: value
  });
};

store.del = function (state) {
  return store.commit('del', {
    state: state
  });
};

store.install = function (Vue) {
  Vue.prototype.$store = store;
};

var _default = store;
exports["default"] = _default;